module.exports = __webpack_public_path__ + "media/images/ui__textArrowLeftLight-e4e351825ef26f6b28c441ca1ce43611.png";